// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)
